import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Welcome from "../../assets/Home/Overview/Welcome.png";
import Tipp from "./Tipp";

export default function StartOnboarding() {
  const { t } = useTranslation();

  const tipText = t("welcomeTip");

  return (
    <Box
      sx={{
        m: { xs: 0, sm: 1, lg: 2 },
      }}
    >
      <Typography variant="h2" sx={{ mt: 3 }}>
        {t("welcomeOnly")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row-reverse" },
          alignItems: "center",
        }}
      >
        <Box sx={{ mb: 2, mt: 4 }}>
          <img src={Welcome} alt="welcome" width={290} />
        </Box>
        <Box sx={{ pt: { xs: 2, sm: 3 } }}>
          <Typography align="left">
            {t("welcome", { website: "Gekonnt hanDeln" })}
          </Typography>
          <br />
          <Typography align="left">{t("welcomeText1")}</Typography>
          <br />
          <Typography align="left">{t("welcomeText2")}</Typography>
          <Paper sx={{bgcolor: "secondary.lightest", my: 1, p: 1}}>
            <Typography fontWeight={500}>Da diese Seite noch in der Entwicklung ist, würden wir uns freuen, wenn Sie an unserer Umfrage teilnehmen. Diese finden Sie über das Menü auf der linken Seite.</Typography>
          </Paper>
          <Typography align="left">{t("welcomeText3")}</Typography>
          <br />
          <Typography align="left">
            {t("welcomeText4", { website: "Gekonnt hanDeln" })}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ mt: 1 }}>
        <Tipp text={tipText} />
      </Box>
    </Box>
  );
}
